import moment from "moment-timezone";

export function convertMinutesFromMidnightToTimeFormat(minutes: number): string {
    const hours = Math.floor(minutes / 60);   // Get full hours
    const remainingMinutes = minutes % 60;   // Get remaining minutes
    
    // Format hours and minutes to two digits
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(remainingMinutes).padStart(2, '0');
    
    return `${formattedHours}:${formattedMinutes}`;
}

export function formatDateToAMPM(dateString:string) {
    const date = new Date(dateString);
    
    const options:any = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
  
    return date.toLocaleString('en-US', options);
}

export function minutesFromMidnight(date:Date) {
  // Create a new Date object for the given date
  const givenDate = new Date(date);

  // Get the time of the day in milliseconds
  const timeInMs = givenDate.getTime();

  // Create a new Date object for midnight (00:00:00) of the same day
  const midnight = new Date(givenDate.setHours(0, 0, 0, 0));

  // Get the time of midnight in milliseconds
  const midnightTimeInMs = midnight.getTime();

  // Calculate the difference in milliseconds and convert it to minutes
  const minutes = Math.floor((timeInMs - midnightTimeInMs) / 60000);

  return minutes;
}

export function getTime(date:any) {
    // return moment(date).tz('America/New_York');
    // const offsetInMinutes = miamiMoment.utcOffset();
    //
    // date = date - (offsetInMinutes * 60 * 1000);
    // console.log(moment(date).tz('America/New_York'))
    return moment.tz(date, 'America/New_York')
}



export function getTimeDifferenceToHoursRange(isoFrom:string | Date, isoTo: string | Date) {

  function getMinutesFromMidnight(isoString: string | number | Date) {
    const date = new Date(isoString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return hours * 60 + minutes;
  }

    const fromDate = new Date(isoFrom);
    const toDate = new Date(isoTo);
    
    // Calculate minutes from midnight for each date
    const fromMinutes = getMinutesFromMidnight(isoFrom);
    const toMinutes = getMinutesFromMidnight(isoTo);
    
    // Calculate difference in days
    const dayDifference = Math.floor(((toDate as any) - (fromDate as any)) / (1000 * 60 * 60 * 24));
    
    // Total minutes from 'from' timestamp to 'to' timestamp
    const totalToMinutes = toMinutes + ((dayDifference * 24) * 60);
    
    return {
      from: fromMinutes,
      to: totalToMinutes
    };
  }